export default "__VITE_ASSET__C_WhK0PR__"